import useDeviceDetect from 'Hooks/useDeviceDetect';
import React from 'react';
import { SidebarStatus } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizard';
import { SelectedTrips } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizardWrap';
import { FerryFilters } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/Sidebar/FerryFilters/FerryFilters';
import { TripSummary } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/Sidebar/TripSummary';

export interface BookingWizardSideBarProps {
	sidebarStatus: SidebarStatus;
	selectedTrips: SelectedTrips;
}

export function BookingWizardSidebar({ sidebarStatus, selectedTrips }: BookingWizardSideBarProps) {
	const { isMobileBookingWizard } = useDeviceDetect();

	const showSideBar = sidebarStatus !== SidebarStatus.NO_SIDEBAR && !isMobileBookingWizard;

	return (
		<div className={`filter-sidebar-container ${showSideBar ? '' : 'hide'} `}>
			{/*
				If this ternary fails, we will be shown the trip summary regardless of whether the status says no
				sidebar. That is fine because if the status is no sidebar then a class to hide the component will be
				added, rendering the summary invisible
			*/}
			{sidebarStatus === SidebarStatus.FILTERS ? (
				<>
					<div className="filter-container">
						<FerryFilters />
					</div>
				</>
			) : (
				<>
					<TripSummary selectedTrips={selectedTrips} />
				</>
			)}
		</div>
	);
}
